import { Tag } from "antd"

const InfoTags = ({ info }) => {
    return (
        <div className="flex flex-wrap gap-2">
            {info.map((item, index) => (
                <Tag key={index}>
                    {item}
                </Tag>
            ))}
        </div>
    )
}

export default InfoTags;
